import api from 'src/Utils/api';
export var createBlockedDate = function (_a) {
    var date = _a.date, general_block = _a.general_block, recurring = _a.recurring, entity_id = _a.entity_id, entity_type = _a.entity_type;
    var body = {
        booking_blocked_date: {
            date: date,
            general_block: general_block,
            recurring: recurring,
        },
    };
    if (entity_id && entity_type) {
        body.booking_blocked_date['entity_id'] = entity_id;
        body.booking_blocked_date['entity_type'] = entity_type;
    }
    return api.post('/booking_blocked_dates', body);
};
